/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


//Product info table append the extra info table 
setTimeout(()=>{
  let parentTable = document.getElementById('parentTableProductInfo');
  if(parentTable){
     let parentTableList = parentTable.querySelector("tbody");
    let childTable = document.getElementById('productInfoExtra');
    let childTableList = childTable.querySelectorAll("tr");
      childTableList.forEach(i=>{
        parentTableList.append(i);
  })
  }
 
},1000)


$(document).ready(function() {
  $("video[data-video-src-deferred]").each(function() {
    var videoSrc = $(this).data("video-src-deferred");
    var videoElement = $(this);
    setTimeout(function() {
      videoElement.attr("src", videoSrc);
    }, 3000); // Delay of 2500 milliseconds (2.5 seconds)
  });
});

// Function to get primary locale 
function getPrimaryLocale(hostname) {
    // Default to Dutch for .nl and .be domains, or for .com domains serving primarily Dutch content
    if (hostname.endsWith('.nl') || hostname.endsWith('.be') || hostname.endsWith('.com')) {
      return 'nl';
    } 
    // Default to French for .fr domains
    else if (hostname.endsWith('.fr')) {
      return 'fr';
    }
    return 'nl'; // Default locale 
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.boost-pfs-filter-top-sorting-wrapper');
    if (!btn) return;

    e.stopPropagation();
    e.preventDefault();

    // Close dropdown if opened
    var dropdown = document.querySelector('.boost-pfs-filter-filter-dropdown');
    if (dropdown) dropdown.style.display = 'none';

    var isMobile = window.innerWidth <= 1360;
    console.log('isMobile:', isMobile, 'width:', window.innerWidth);

    if (isMobile) {
      // Try both possible selectors for the filter toggle button
      var filterToggle = document.querySelector('button[aria-label="Verfijn op"]') 
                      || document.querySelector('button[aria-label="Verfijn Op"]')
                      || document.querySelector('.boost-pfs-filter-tree-mobile-button button');
      
      console.log('Filter toggle found:', filterToggle);

      if (filterToggle) {
        filterToggle.click();
        console.log('Mobile filter panel opened');

        setTimeout(function() {
          var kleurBtn = document.querySelector('.boost-pfs-filter-option-kleur .boost-pfs-filter-option-title-heading');
          console.log('Kleur button found:', kleurBtn);
          if (kleurBtn) {
            kleurBtn.click();
            console.log('Kleur filter clicked');
          }
        }, 600); // increased timeout for real devices
      }

    } else {
      var colorFilter = document.querySelector('.boost-pfs-filter-option-kleur');
      if (colorFilter) {
        var headerOffset = 80;
        var offsetPosition = colorFilter.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ behavior: 'smooth', top: offsetPosition });
      }
    }

  }, true);
});



function moveCollectionHeader() {
  var header = document.getElementById('kissCollectionHeaderWrap');
  var desktopTarget = document.getElementById('kissCollectionHeaderDesktopTarget');
  var mobileTarget = document.querySelector('.boost-pfs-filter-toolbar-top-mobile');

  if (!header) return;

  if (window.innerWidth > 1360) {
    if (desktopTarget && !desktopTarget.contains(header)) {
      desktopTarget.appendChild(header);
    }
  } else {
    if (mobileTarget && !mobileTarget.contains(header)) {
      mobileTarget.parentNode.insertBefore(header, mobileTarget);
    }
  }
}

moveCollectionHeader();
window.addEventListener('resize', moveCollectionHeader);

document.addEventListener("click", function (e) {
  const badge = e.target.closest(".jdgm-preview-badge.jdgm-preview-badge--with-link");

  if (!badge) return;

  e.preventDefault();

  const reviewSection = document.querySelector(
    '[id*="judge_me_reviews_featured_carousel"]'
  );

  if (!reviewSection) return;

  const rect = reviewSection.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Center the section in the viewport
  const targetPosition =
    rect.top + scrollTop - (window.innerHeight / 2) + (reviewSection.offsetHeight / 2);

  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
}, true);